export default "__VITE_ASSET__BVGTN_Qc__"